import React, { useState, useEffect } from 'react'
import { GoDotFill } from 'react-icons/go'

import { useIssueStore } from './store/IssueStore'

import { Box } from '@mui/material'
// import { useGovernanceStore } from '../Onboarding/Store/GovernanceStore'

const IssuePending = () => {
    const issueDetailsData = useIssueStore(state => state.issueDetailsById)
    const [ formData, setFormData ] = useState({})

    // const [ departments, setDepartments ] = useState([])
    // const { allDepartments } = useGovernanceStore()

    // useEffect(() => {
    //     if (allDepartments.length > 0) {
    //         setDepartments(allDepartments)
    //     }
    // }, [allDepartments])

    useEffect(() => {
        if (issueDetailsData?.lessonLearntResponse) {
            setFormData(issueDetailsData?.lessonLearntResponse)
        }
    }, [issueDetailsData])

    return (
        <div className='text-primary overflow-auto flex flex-col gap-7 p-5'>
            <div className='text-primary text-subHeading-2 p-3 rounded-md bg-[hsl(var(--primary-table-head))] w-[100%] flex items-center gap-2'><GoDotFill size={8} /> Lessons Learnt</div>
            <Box display="grid" sx={{ pb: 2 }} gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                <Box gridColumn="span 1">
                    <div className="flex">
                        <p className="text-[hsl(var(--primary))] text-subHeading-2">Monitory Benefit :</p>
                        <p className="text-muted text-b5 pl-2">
                            {formData?.monitoryBenefit}
                        </p>
                    </div>
                </Box>
                <Box gridColumn="span 1">
                    <div className="flex">
                        <p className="text-[hsl(var(--primary))] text-subHeading-2">Turn Around Time :</p>
                        <p className="text-muted text-b5 pl-2">
                            {formData?.turnAroundTime}
                        </p>
                    </div>
                </Box>
                <Box gridColumn="span 1">
                    <div className="flex">
                        <p className="text-[hsl(var(--primary))] text-subHeading-2">Root Cause :</p>
                        <p className="text-muted text-b5 pl-2">
                            {formData?.rootCause}
                        </p>
                    </div>
                </Box>
            </Box>
            <Box display="grid" sx={{ pb: 2 }} gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                <Box gridColumn="span 1">
                    <div className="flex flex-col">
                        <p className="text-[hsl(var(--primary))] text-subHeading-2">{'What went wrong (Challenges)'}</p>
                        <p className="text-muted text-b5">
                            {formData?.wrong}
                        </p>
                    </div>
                </Box>
                <Box gridColumn="span 1">
                    <div className="flex flex-col">
                        <p className="text-[hsl(var(--primary))] text-subHeading-2">{'What went right (Successes)'}</p>
                        <p className="text-muted text-b5">
                            {formData?.right}
                        </p>
                    </div>
                </Box>
                <Box gridColumn="span 1">
                    <div className="flex flex-col">
                        <p className="text-[hsl(var(--primary))] text-subHeading-2">What needs to be improved</p>
                        <p className="text-muted text-b5">
                            {formData?.improved}
                        </p>
                    </div>
                </Box>
            </Box>

        </div>
    )
}

export default IssuePending
